export const countryAlphaMapping = {
  AF: 'AFG',
  AX: 'ALA',
  AL: 'ALB',
  DZ: 'DZA',
  AS: 'ASM',
  AD: 'AND',
  AO: 'AGO',
  AI: 'AIA',
  AQ: 'ATA',
  AG: 'ATG',
  AR: 'ARG',
  AM: 'ARM',
  AW: 'ABW',
  AU: 'AUS',
  AT: 'AUT',
  AZ: 'AZE',
  BS: 'BHS',
  BH: 'BHR',
  BD: 'BGD',
  BB: 'BRB',
  BY: 'BLR',
  BE: 'BEL',
  BZ: 'BLZ',
  BJ: 'BEN',
  BM: 'BMU',
  BT: 'BTN',
  BO: 'BOL',
  BA: 'BIH',
  BW: 'BWA',
  BV: 'BVT',
  BR: 'BRA',
  VG: 'VGB',
  IO: 'IOT',
  BN: 'BRN',
  BG: 'BGR',
  BF: 'BFA',
  BI: 'BDI',
  KH: 'KHM',
  CM: 'CMR',
  CA: 'CAN',
  CV: 'CPV',
  KY: 'CYM',
  CF: 'CAF',
  TD: 'TCD',
  CL: 'CHL',
  CN: 'CHN',
  HK: 'HKG',
  MO: 'MAC',
  CX: 'CXR',
  CC: 'CCK',
  CO: 'COL',
  KM: 'COM',
  CG: 'COG',
  CD: 'COD',
  CK: 'COK',
  CR: 'CRI',
  CI: 'CIV',
  HR: 'HRV',
  CU: 'CUB',
  CY: 'CYP',
  CZ: 'CZE',
  DK: 'DNK',
  DJ: 'DJI',
  DM: 'DMA',
  DO: 'DOM',
  EC: 'ECU',
  EG: 'EGY',
  SV: 'SLV',
  GQ: 'GNQ',
  ER: 'ERI',
  EE: 'EST',
  ET: 'ETH',
  FK: 'FLK',
  FO: 'FRO',
  FJ: 'FJI',
  FI: 'FIN',
  FR: 'FRA',
  GF: 'GUF',
  PF: 'PYF',
  TF: 'ATF',
  GA: 'GAB',
  GM: 'GMB',
  GE: 'GEO',
  DE: 'DEU',
  GH: 'GHA',
  GI: 'GIB',
  GR: 'GRC',
  GL: 'GRL',
  GD: 'GRD',
  GP: 'GLP',
  GU: 'GUM',
  GT: 'GTM',
  GG: 'GGY',
  GN: 'GIN',
  GW: 'GNB',
  GY: 'GUY',
  HT: 'HTI',
  HM: 'HMD',
  VA: 'VAT',
  HN: 'HND',
  HU: 'HUN',
  IS: 'ISL',
  IN: 'IND',
  ID: 'IDN',
  IR: 'IRN',
  IQ: 'IRQ',
  IE: 'IRL',
  IM: 'IMN',
  IL: 'ISR',
  IT: 'ITA',
  JM: 'JAM',
  JP: 'JPN',
  JE: 'JEY',
  JO: 'JOR',
  KZ: 'KAZ',
  KE: 'KEN',
  KI: 'KIR',
  KP: 'PRK',
  KR: 'KOR',
  KW: 'KWT',
  KG: 'KGZ',
  LA: 'LAO',
  LV: 'LVA',
  LB: 'LBN',
  LS: 'LSO',
  LR: 'LBR',
  LY: 'LBY',
  LI: 'LIE',
  LT: 'LTU',
  LU: 'LUX',
  MK: 'MKD',
  MG: 'MDG',
  MW: 'MWI',
  MY: 'MYS',
  MV: 'MDV',
  ML: 'MLI',
  MT: 'MLT',
  MH: 'MHL',
  MQ: 'MTQ',
  MR: 'MRT',
  MU: 'MUS',
  YT: 'MYT',
  MX: 'MEX',
  FM: 'FSM',
  MD: 'MDA',
  MC: 'MCO',
  MN: 'MNG',
  ME: 'MNE',
  MS: 'MSR',
  MA: 'MAR',
  MZ: 'MOZ',
  MM: 'MMR',
  NA: 'NAM',
  NR: 'NRU',
  NP: 'NPL',
  NL: 'NLD',
  AN: 'ANT',
  NC: 'NCL',
  NZ: 'NZL',
  NI: 'NIC',
  NE: 'NER',
  NG: 'NGA',
  NU: 'NIU',
  NF: 'NFK',
  MP: 'MNP',
  NO: 'NOR',
  OM: 'OMN',
  PK: 'PAK',
  PW: 'PLW',
  PS: 'PSE',
  PA: 'PAN',
  PG: 'PNG',
  PY: 'PRY',
  PE: 'PER',
  PH: 'PHL',
  PN: 'PCN',
  PL: 'POL',
  PT: 'PRT',
  PR: 'PRI',
  QA: 'QAT',
  RE: 'REU',
  RO: 'ROU',
  RU: 'RUS',
  RW: 'RWA',
  BL: 'BLM',
  SH: 'SHN',
  KN: 'KNA',
  LC: 'LCA',
  MF: 'MAF',
  PM: 'SPM',
  VC: 'VCT',
  WS: 'WSM',
  SM: 'SMR',
  ST: 'STP',
  SA: 'SAU',
  SN: 'SEN',
  RS: 'SRB',
  SC: 'SYC',
  SL: 'SLE',
  SG: 'SGP',
  SK: 'SVK',
  SI: 'SVN',
  SB: 'SLB',
  SO: 'SOM',
  ZA: 'ZAF',
  GS: 'SGS',
  SS: 'SSD',
  ES: 'ESP',
  LK: 'LKA',
  SD: 'SDN',
  SR: 'SUR',
  SJ: 'SJM',
  SZ: 'SWZ',
  SE: 'SWE',
  CH: 'CHE',
  SY: 'SYR',
  TW: 'TWN',
  TJ: 'TJK',
  TZ: 'TZA',
  TH: 'THA',
  TL: 'TLS',
  TG: 'TGO',
  TK: 'TKL',
  TO: 'TON',
  TT: 'TTO',
  TN: 'TUN',
  TR: 'TUR',
  TM: 'TKM',
  TC: 'TCA',
  TV: 'TUV',
  UG: 'UGA',
  UA: 'UKR',
  AE: 'ARE',
  GB: 'GBR',
  US: 'USA',
  UM: 'UMI',
  UY: 'URY',
  UZ: 'UZB',
  VU: 'VUT',
  VE: 'VEN',
  VN: 'VNM',
  VI: 'VIR',
  WF: 'WLF',
  EH: 'ESH',
  YE: 'YEM',
  ZM: 'ZMB',
  ZW: 'ZWE',
};

export const statesOfUS = [
  { value: 'Armed Forces America', label: 'us.state_aa' },
  { value: 'Armed Forces', label: 'us.state_ae' },
  { value: 'Armed Forces Pacific', label: 'us.state_ap' },
  { value: 'Alaska', label: 'us.state_ak' },
  { value: 'Alabama', label: 'us.state_al' },
  { value: 'Arizona', label: 'us.state_az' },
  { value: 'Arkansas', label: 'us.state_ar' },
  { value: 'California', label: 'us.state_ca' },
  { value: 'Colorado', label: 'us.state_co' },
  { value: 'Connecticut', label: 'us.state_ct' },
  { value: 'Washington DC', label: 'us.state_wd' },
  { value: 'Delaware', label: 'us.state_de' },
  { value: 'Florida', label: 'us.state_fl' },
  { value: 'Georgia', label: 'us.state_ga' },
  { value: 'Guam', label: 'us.state_gu' },
  { value: 'Hawaii', label: 'us.state_hi' },
  { value: 'Idaho', label: 'us.state_id' },
  { value: 'Illinois', label: 'us.state_il' },
  { value: 'Indiana', label: 'us.state_in' },
  { value: 'Iowa', label: 'us.state_ia' },
  { value: 'Kansas', label: 'us.state_ks' },
  { value: 'Kentucky', label: 'us.state_ky' },
  { value: 'Louisiana', label: 'us.state_la' },
  { value: 'Maine', label: 'us.state_me' },
  { value: 'Maryland', label: 'us.state_md' },
  { value: 'Massachusetts', label: 'us.state_ma' },
  { value: 'Michigan', label: 'us.state_mi' },
  { value: 'Minnesota', label: 'us.state_mn' },
  { value: 'Mississippi', label: 'us.state_ms' },
  { value: 'Missouri', label: 'us.state_mo' },
  { value: 'Montana', label: 'us.state_mt' },
  { value: 'Nebraska', label: 'us.state_ne' },
  { value: 'Nevada', label: 'us.state_nv' },
  { value: 'New Hampshire', label: 'us.state_nh' },
  { value: 'New Jersey', label: 'us.state_nj' },
  { value: 'New Mexico', label: 'us.state_nm' },
  { value: 'New York', label: 'us.state_ny' },
  { value: 'North Carolina', label: 'us.state_nc' },
  { value: 'North Dakota', label: 'us.state_nd' },
  { value: 'Ohio', label: 'us.state_oh' },
  { value: 'Oklahoma', label: 'us.state_ok' },
  { value: 'Oregon', label: 'us.state_or' },
  { value: 'Pennsylvania', label: 'us.state_pa' },
  { value: 'Puerto Rico', label: 'us.state_pr' },
  { value: 'Rhode Island', label: 'us.state_ri' },
  { value: 'South Carolina', label: 'us.state_sc' },
  { value: 'South Dakota', label: 'us.state_sd' },
  { value: 'Tennessee', label: 'us.state_tn' },
  { value: 'Texas', label: 'us.state_tx' },
  { value: 'Utah', label: 'us.state_ut' },
  { value: 'Vermont', label: 'us.state_vt' },
  { value: 'Virginia', label: 'us.state_va' },
  { value: 'Virgin Islands', label: 'us.state_vi' },
  { value: 'Washington', label: 'us.state_wa' },
  { value: 'West Virginia', label: 'us.state_wv' },
  { value: 'Wisconsin', label: 'us.state_wi' },
  { value: 'Wyoming', label: 'us.state_wy' },
];

export const US_short = {
  AA: 'Armed Forces America',
  AE: 'Armed Forces',
  AK: 'Alaska',
  AL: 'Alabama',
  AP: 'Armed Forces Pacific',
  AR: 'Arkansas',
  AS: 'American Samoa',
  AZ: 'Arizona',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DC: 'Washington DC',
  DE: 'Delaware',
  FL: 'Florida',
  FM: 'Federated States of Micronesia',
  GA: 'Georgia',
  GU: 'Guam',
  HI: 'Hawaii',
  IA: 'Iowa',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  MA: 'Massachusetts',
  MD: 'Maryland',
  ME: 'Maine',
  MH: 'Marshall Islands',
  MI: 'Michigan',
  MN: 'Minnesota',
  MO: 'Missouri',
  MP: 'Northern Mariana Islands',
  MS: 'Mississippi',
  MT: 'Montana',
  NC: 'North Carolina',
  ND: 'North Dakota',
  NE: 'Nebraska',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NV: 'Nevada',
  NY: 'New York',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  PR: 'Puerto Rico',
  PW: 'Palau',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VA: 'Virginia',
  VI: 'Virgin Islands',
  VT: 'Vermont',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
};

export const statesOfCA = [
  { value: 'Alberta', label: 'ca.state_aa' },
  { value: 'British Columbia', label: 'ca.state_ba' },
  { value: 'Manitoba', label: 'ca.state_ma' },
  { value: 'New Brunswick', label: 'ca.state_nd' },
  { value: 'Newfoundland and Labrador', label: 'ca.state_nr' },
  { value: 'Northwest Territories', label: 'ca.state_ns' },
  { value: 'Nova Scotia', label: 'ca.state_na' },
  { value: 'Nunavut', label: 'ca.state_nt' },
  { value: 'Ontario', label: 'ca.state_oo' },
  { value: 'Prince Edward Island', label: 'ca.state_pe' },
  { value: 'Quebec', label: 'ca.state_qc' },
  { value: 'Saskatchewan', label: 'ca.state_sn' },
  { value: 'Yukon', label: 'ca.state_yn' },
];

export const statesOfIN = [
  { value: 'Andaman and Nicobar', label: 'inr.state_an' },
  { value: 'Andhra Pradesh', label: 'inr.state_ap' },
  { value: 'Arunachal Pradesh', label: 'inr.state_ar' },
  { value: 'Assam', label: 'inr.state_as' },
  { value: 'Bihar', label: 'inr.state_br' },
  { value: 'Chandigarh', label: 'inr.state_ch' },
  { value: 'Chhattisgarh', label: 'inr.state_cg' },
  { value: 'Dadra Nagar Havelli', label: 'inr.state_dnh' },
  { value: 'Daman and Diu', label: 'inr.state_dd' },
  { value: 'Delhi', label: 'inr.state_dl' },
  { value: 'Goa', label: 'inr.state_ga' },
  { value: 'Gujarat', label: 'inr.state_gj' },
  { value: 'Haryana', label: 'inr.state_hr' },
  { value: 'Himachal Pradesh', label: 'inr.state_hp' },
  { value: 'Jammu and Kashmir', label: 'inr.state_jk' },
  { value: 'Jharkhand', label: 'inr.state_jh' },
  { value: 'Karnataka', label: 'inr.state_ka' },
  { value: 'Kerala', label: 'inr.state_kl' },
  { value: 'Ladakh', label: 'inr.state_la' },
  { value: 'Lakshadweep', label: 'inr.state_ld' },
  { value: 'Madhya Pradesh', label: 'inr.state_mp' },
  { value: 'Maharashtra', label: 'inr.state_mh' },
  { value: 'Manipur', label: 'inr.state_mn' },
  { value: 'Meghalaya', label: 'inr.state_ml' },
  { value: 'Mizoram', label: 'inr.state_mz' },
  { value: 'Nagaland', label: 'inr.state_nl' },
  { value: 'Orissa', label: 'inr.state_or' },
  { value: 'Other Country', label: 'inr.state_oc' },
  { value: 'Other Territory', label: 'inr.state_ot' },
  { value: 'Puducherry', label: 'inr.state_ph' },
  { value: 'Punjab', label: 'inr.state_pb' },
  { value: 'Rajasthan', label: 'inr.state_rj' },
  { value: 'Sikkim', label: 'inr.state_sk' },
  { value: 'Tamil Nadu', label: 'inr.state_tn' },
  { value: 'Telangana', label: 'inr.state_tg' },
  { value: 'Tripura', label: 'inr.state_tr' },
  { value: 'Uttar Pradesh', label: 'inr.state_up' },
  { value: 'Uttarakhand', label: 'inr.state_uk' },
  { value: 'West Bengal', label: 'inr.state_wb' },
];

export const taxStatesInCA = ['Quebec', 'British Columbia', 'Manitoba'];
export const gstCountries = ['AU', 'SG', 'NZ', 'MX', 'SA', 'RU', 'ZA', 'AE', 'KR', 'CA', 'ID'];
export const nonValidationCountries = [
  'NZ',
  'CH',
  'MX',
  'SA',
  'IN',
  'RU',
  'ZA',
  'AE',
  'KR',
  'CA',
  'ID',
  'CL',
  'TR',
  'NO',
];
export const euCountries = [
  'AT',
  'BE',
  'BG',
  'CY',
  'CZ',
  'DE',
  'DK',
  'EE',
  'ES',
  'FI',
  'FR',
  'GB',
  'GR',
  'HR',
  'HU',
  'IE',
  'IT',
  'LT',
  'LU',
  'LV',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SE',
  'SI',
  'SK',
  'EU',
  'AU',
  'SG',
  'NZ',
  'CH',
  'MX',
  'SA',
  'RU',
  'ZA',
  'AE',
  'KR',
  'CA',
  'ID',
];
export const taxConfigMap = {
  CL: {
    type: 'input',
    message: 'billing.tax_promote_cl',
    placeholder: 'billing.rut_number',
    validRegex: /^(\w{9})$/,
    ignoreRegex: /-|\s|\./g,
    checkBoxMessage: 3,
    checkBoxDesc: 3,
    invertCheckbox: true,
    isEmptiable: true,
  },
  CO: {
    type: 'dropdown',
    message: 'billing.tax_promote_co',
    dropdownValue: [
      {
        text: 'billing.tax_list_co_0',
        val: 0,
        selected: 'selected',
      },
      {
        text: 'billing.tax_list_co_1',
        val: 1,
      },
      {
        text: 'billing.tax_list_co_2',
        val: 2,
      },
    ],
    checkBoxMessage: 0,
    checkBoxDesc: 0,
  },
  TR: {
    type: 'input',
    message: 'billing.tax_promote_tr',
    prefix: 'VAT',
    validRegex: /^\d{10,11}$/,
    checkBoxMessage: 1,
    checkBoxDesc: 2,
  },
  NO: {
    type: 'input',
    message: 'billing.tax_promote_no',
    placeholder: 'billing.mva_number',
    validRegex: /^\d{9}$/,
    suffix: 'MVA',
    checkBoxMessage: 1,
    checkBoxDesc: 2,
  },
  IN: {
    type: 'input',
    message: 'billing.inMsg',
    placeholder: 'billing.gst_number',
    validRegex: /^\d{2}[A-Za-z0-9]{13}$/,
    checkBoxMessage: 3,
    checkBoxDesc: 3,
    invertCheckbox: true,
    isEmptiable: true,
  },
};

export const COUNTRY_CODES_BY_ZUORA_COUNTRY = {
  Afghanistan: 'AF',
  'Aland Islands': 'AX',
  Albania: 'AL',
  Algeria: 'DZ',
  'American Samoa': 'AS',
  Andorra: 'AD',
  Angola: 'AO',
  Anguilla: 'AI',
  Antarctica: 'AQ',
  'Antigua And Barbuda': 'AG',
  Argentina: 'AR',
  Armenia: 'AM',
  Aruba: 'AW',
  Australia: 'AU',
  Austria: 'AT',
  Azerbaijan: 'AZ',
  Bahamas: 'BS',
  Bahrain: 'BH',
  Bangladesh: 'BD',
  Barbados: 'BB',
  Belarus: 'BY',
  Belgium: 'BE',
  Belize: 'BZ',
  Benin: 'BJ',
  Bermuda: 'BM',
  Bhutan: 'BT',
  Bolivia: 'BO',
  'Bonaire, Saint Eustatius and Saba': 'BQ',
  'Bosnia and Herzegovina': 'BA',
  Botswana: 'BW',
  'Bouvet Island': 'BV',
  Brazil: 'BR',
  'British Indian Ocean Territory': 'IO',
  'Brunei Darussalam': 'BN',
  Bulgaria: 'BG',
  'Burkina Faso': 'BF',
  Burundi: 'BI',
  Cambodia: 'KH',
  Cameroon: 'CM',
  Canada: 'CA',
  'Cape Verde': 'CV',
  'Cayman Islands': 'KY',
  'Central African Republic': 'CF',
  Chad: 'TD',
  Chile: 'CL',
  China: 'CN',
  'Christmas Island': 'CX',
  'Cocos (Keeling) Islands': 'CC',
  Colombia: 'CO',
  Comoros: 'KM',
  Congo: 'CG',
  'Congo, the Democratic Republic of the': 'CD',
  'Cook Islands': 'CK',
  'Costa Rica': 'CR',
  "Cote d'Ivoire": 'CI',
  Croatia: 'HR',
  Cuba: 'CU',
  Curacao: 'CW',
  Cyprus: 'CY',
  'Czech Republic': 'CZ',
  Denmark: 'DK',
  Djibouti: 'DJ',
  Dominica: 'DM',
  'Dominican Republic': 'DO',
  Ecuador: 'EC',
  Egypt: 'EG',
  'El Salvador': 'SV',
  'Equatorial Guinea': 'GQ',
  Eritrea: 'ER',
  Estonia: 'EE',
  Ethiopia: 'ET',
  'Falkland Islands (Malvinas)': 'FK',
  'Faroe Islands': 'FO',
  Fiji: 'FJ',
  Finland: 'FI',
  France: 'FR',
  'French Guiana': 'GF',
  'French Polynesia': 'PF',
  'French Southern Territories': 'TF',
  Gabon: 'GA',
  Gambia: 'GM',
  Georgia: 'GE',
  Germany: 'DE',
  Ghana: 'GH',
  Gibraltar: 'GI',
  Greece: 'GR',
  Greenland: 'GL',
  Grenada: 'GD',
  Guadeloupe: 'GP',
  Guam: 'GU',
  Guatemala: 'GT',
  Guernsey: 'GG',
  Guinea: 'GN',
  'Guinea-Bissau': 'GW',
  Guyana: 'GY',
  Haiti: 'HT',
  'Heard Island and McDonald Islands': 'HM',
  'Holy See (Vatican City State)': 'VA',
  Honduras: 'HN',
  'Hong Kong': 'HK',
  Hungary: 'HU',
  Iceland: 'IS',
  India: 'IN',
  Indonesia: 'ID',
  'Iran, Islamic Republic of': 'IR',
  Iraq: 'IQ',
  Ireland: 'IE',
  'Isle of Man': 'IM',
  Israel: 'IL',
  Italy: 'IT',
  Jamaica: 'JM',
  Japan: 'JP',
  Jersey: 'JE',
  Jordan: 'JO',
  Kazakhstan: 'KZ',
  Kenya: 'KE',
  Kiribati: 'KI',
  "Korea, Democratic People's Republic of": 'KP',
  'Korea, Republic of': 'KR',
  Kosovo: 'XK',
  Kuwait: 'KW',
  Kyrgyzstan: 'KG',
  "Lao People's Democratic Republic": 'LA',
  Latvia: 'LV',
  Lebanon: 'LB',
  Lesotho: 'LS',
  Liberia: 'LR',
  Libya: 'LY',
  'Libyan Arab Jamahiriya': 'LY',
  Liechtenstein: 'LI',
  Lithuania: 'LT',
  Luxembourg: 'LU',
  Macao: 'MO',
  Macau: 'MO',
  'Macedonia, the former Yugoslav Republic of': 'MK',
  Madagascar: 'MG',
  Malawi: 'MW',
  Malaysia: 'MY',
  Maldives: 'MV',
  Mali: 'ML',
  Malta: 'MT',
  'Marshall Islands': 'MH',
  Martinique: 'MQ',
  Mauritania: 'MR',
  Mauritius: 'MU',
  Mayotte: 'YT',
  Mexico: 'MX',
  'Micronesia, Federated States of': 'FM',
  'Moldova, Republic of': 'MD',
  Monaco: 'MC',
  Mongolia: 'MN',
  Montenegro: 'ME',
  Montserrat: 'MS',
  Morocco: 'MA',
  Mozambique: 'MZ',
  Myanmar: 'MM',
  Namibia: 'NA',
  Nauru: 'NR',
  Nepal: 'NP',
  Netherlands: 'NL',
  'New Caledonia': 'NC',
  'New Zealand': 'NZ',
  Nicaragua: 'NI',
  Niger: 'NE',
  Nigeria: 'NG',
  Niue: 'NU',
  'Norfolk Island': 'NF',
  'Northern Mariana Islands': 'MP',
  Norway: 'NO',
  Oman: 'OM',
  Pakistan: 'PK',
  Palau: 'PW',
  'Palestinian Territory, Occupied': 'PS',
  Panama: 'PA',
  'Papua New Guinea': 'PN',
  Paraguay: 'PY',
  Peru: 'PE',
  Philippines: 'PH',
  Pitcairn: 'PN',
  Poland: 'PL',
  Portugal: 'PT',
  'Puerto Rico': 'PR',
  Qatar: 'QA',
  Reunion: 'RE',
  Romania: 'RO',
  'Russian Federation': 'RU',
  Rwanda: 'RW',
  'Saint Barthelemy': 'BL',
  'Saint Helena': 'SH',
  'Saint Kitts and Nevis': 'KN',
  'Saint Lucia': 'LC',
  'Saint Martin (French part)': 'MF',
  'Saint Pierre and Miquelon': 'PM',
  'Saint Vincent and the Grenadines': 'VC',
  Samoa: 'WS',
  'San Marino': 'SM',
  'Sao Tome and Principe': 'ST',
  'Saudi Arabia': 'SA',
  Senegal: 'SN',
  Serbia: 'RS',
  Seychelles: 'SC',
  'Sierra Leone': 'SL',
  Singapore: 'SG',
  'Sint Maarten': 'SX',
  Slovakia: 'SK',
  Slovenia: 'SI',
  'Solomon Islands': 'SB',
  Somalia: 'SO',
  'South Africa': 'ZA',
  'South Georgia and the South Sandwich Islands': 'GS',
  'South Sudan': 'SS',
  Spain: 'ES',
  'Sri Lanka': 'LK',
  Sudan: 'SD',
  Suriname: 'SR',
  'Svalbard and Jan Mayen': 'SJ',
  Swaziland: 'SZ',
  Sweden: 'SE',
  Switzerland: 'CH',
  'Syrian Arab Republic': 'SY',
  Taiwan: 'TW',
  Tajikistan: 'TJ',
  'Tanzania, United Republic of': 'TZ',
  Thailand: 'TH',
  'Timor-Leste': 'TL',
  Togo: 'TG',
  Tokelau: 'TK',
  Tonga: 'TO',
  'Trinidad and Tobago': 'TT',
  Tunisia: 'TN',
  Turkey: 'TR',
  Turkmenistan: 'TM',
  'Turks and Caicos Islands': 'TC',
  Tuvalu: 'TV',
  Uganda: 'UG',
  Ukraine: 'UA',
  'United Arab Emirates': 'AE',
  'United Kingdom': 'GB',
  'United States': 'US',
  'United States Minor Outlying Islands': 'UM',
  Uruguay: 'UY',
  Uzbekistan: 'UZ',
  Vanuatu: 'VU',
  Venezuela: 'VE',
  'Viet Nam': 'VN',
  'Virgin Islands, British': 'VG',
  'Virgin Islands, U.S.': 'VI',
  'Wallis and Futuna': 'WF',
  'Western Sahara': 'EH',
  Yemen: 'YE',
  Zambia: 'ZM',
  Zimbabwe: 'ZW',
};
